/**
 * Copyright © 2024 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
import dayjs from 'dayjs'

import advancedFormat from 'dayjs/plugin/advancedFormat'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import relativeTime from 'dayjs/plugin/relativeTime'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'

dayjs.extend(advancedFormat)
dayjs.extend(weekOfYear)
dayjs.extend(relativeTime)
dayjs.extend(isSameOrAfter)

export * from './src'
